import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import Cookies from 'js-cookie';
import { environment } from 'environments/environment';

// Configuration constants go here
// TODO: Read this from a JSON file
@Injectable()
export class Configuration {

    private static _headers: Headers = new Headers();

    private static _uploadHeaders: Headers = new Headers({});

    get apiUrl(): string {

        //let uri = this.getCookie('agatex_api') || 'api';
        let uri = environment.production ? this.getCookie('agatex_api') || 'api' : 'debug';
        return `https://mysticerp.ro/${uri}`;
    }

    get headers(): Headers {
        return Configuration._headers;
    }

    get uploadHeaders(): Headers {
        return Configuration._uploadHeaders;
    }

    public getStorage(key: string): string {
        if (window.localStorage) {
            return window.localStorage.getItem(key);
        }
    }

    public getCookie(key: string): string {
        if(Cookies) {
            return Cookies.get(key);
        }
    }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/app.constants.ts